import React, { Fragment } from 'react';
import _ from 'lodash';

export const LANGUAGES = {
	DEFAULT: 'English',
	CHINESE: '中文'
};

export const LANGUAGE_INFO = {
	[LANGUAGES.DEFAULT]: {
		title: 'English',
		shortTitle: 'EN'
	},
	[LANGUAGES.CHINESE]: {
		title: '中文',
		shortTitle: '中文',
		codes: ['zh', 'zh-cn', 'zh-hk', 'zh-tw', 'zh-sg']
	}
};

export const messages = {

	HOME_PAGE: {
		MODALS: {
			ERROR: {
				[LANGUAGES.CHINESE]: '錯誤',
				[LANGUAGES.DEFAULT]: 'Error'
			},
			TOP_CHANNELS_ERROR: {
				[LANGUAGES.CHINESE]: '最受歡迎頻道刷新失敗',
				[LANGUAGES.DEFAULT]: 'Error while loading Top Channels'
			},
			LOGIN_ERROR: {
				[LANGUAGES.CHINESE]: '您沒有以此頻道註冊的ViewIQ賬號。請註冊並開設您的賬號。',
				[LANGUAGES.DEFAULT]: 'It looks like you haven\'t created an account with ViewIQ using this channel before. Please Sign Up and create your account'
			},
			LOGIN_ERROR_TITLE: {
				[LANGUAGES.CHINESE]: '登錄失敗',
				[LANGUAGES.DEFAULT]: 'Login failed'
			},
			SIGN_UP: {
				[LANGUAGES.CHINESE]: '註冊',
				[LANGUAGES.DEFAULT]: 'Sign Up'
			},
			CANCEL: {
				[LANGUAGES.CHINESE]: '取消',
				[LANGUAGES.DEFAULT]: 'Cancel'
			},
			CHANNEL_VERIFICATION_ERROR: {
				[LANGUAGES.CHINESE]: '頻道認證失敗，請稍後再試。',
				[LANGUAGES.DEFAULT]: 'Channel verification error. Please try again later.'
			},
			PLEASE_WAIT: {
				[LANGUAGES.CHINESE]: '請稍候...',
				[LANGUAGES.DEFAULT]: 'Please wait...'
			},
			ACCEPT: {
				[LANGUAGES.CHINESE]: '接受',
				[LANGUAGES.DEFAULT]: 'Accept'
			},
			REFUSE: {
				[LANGUAGES.CHINESE]: '拒絕',
				[LANGUAGES.DEFAULT]: 'Refuse'
			},
			TOC: {
				[LANGUAGES.CHINESE]: 'Channel Factory服務與私隱條款',
				[LANGUAGES.DEFAULT]: 'Channel Factory Terms of Service and Privacy Policy'
			}
		},
		MENU_ITEMS: {
			VALUES: {
				[LANGUAGES.CHINESE]: '產品價值',
				[LANGUAGES.DEFAULT]: 'VALUES'
			},
			TESTIMONIALS: {
				[LANGUAGES.CHINESE]: '創作者推薦',
				[LANGUAGES.DEFAULT]: 'TESTIMONIALS'
			},
			FEATURES: {
				[LANGUAGES.CHINESE]: '產品特點',
				[LANGUAGES.DEFAULT]: 'FEATURES'
			},
			ABOUT_US: {
				[LANGUAGES.CHINESE]: '關於我們',
				[LANGUAGES.DEFAULT]: 'ABOUT US'
			},
			BRANDS: {
				[LANGUAGES.CHINESE]: '合作品牌',
				[LANGUAGES.DEFAULT]: 'BRANDS'
			},
			FAQ: {
				[LANGUAGES.CHINESE]: '常見問題',
				[LANGUAGES.DEFAULT]: 'FAQ'
			}
		},
		HEADER: {
			TITLE: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						加入<strong>Channel Factory</strong>社群
						成為官方認證視頻創作者
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						Join Our Community of<br/>
						<strong>Factory Verified</strong> Creators
					</Fragment>
				)
			},
			SIGN_UP: {
				[LANGUAGES.CHINESE]: '註冊',
				[LANGUAGES.DEFAULT]: 'Sign up'
			},
			SIGN_IN: {
				[LANGUAGES.CHINESE]: '簽到',
				[LANGUAGES.DEFAULT]: 'Sign In'
			}
		},
		VALUES_SLIDE: {
			TITLE: {
				[LANGUAGES.CHINESE]: 'Channel Factory是YouTube最大的廣告商之一',
				[LANGUAGES.DEFAULT]: 'Channel Factory is one of the largest Ad Buyers on YouTube'
			},
			SUB_TITLE: {
				[LANGUAGES.CHINESE]: '我們的獲獎軟件可以幫助您：',
				[LANGUAGES.DEFAULT]: 'Our Award Winning Software Can Help YOU:'
			},
			STEP_1: {
				[LANGUAGES.CHINESE]: '提高廣告商的關注度',
				[LANGUAGES.DEFAULT]: 'Boost Visibility with Advertisers'
			},
			STEP_2: {
				[LANGUAGES.CHINESE]: '提高內容質量和觀眾關注度',
				[LANGUAGES.DEFAULT]: 'Improve Content Performance'
			},
			STEP_3: {
				[LANGUAGES.CHINESE]: '瞭解競爭對手發佈的內容',
				[LANGUAGES.DEFAULT]: 'See what your competitors are publishing'
			}
		},
		TESTIMONIALS_SLIDE: {
			TITLE: {
				[LANGUAGES.CHINESE]: '看看經我們認證的視頻創作者的評價',
				[LANGUAGES.DEFAULT]: 'What some of our Channel Verified Creators Are Saying'
			},
			WHY_JOIN: {
				[LANGUAGES.CHINESE]: '為何要加入我們的社群？',
				[LANGUAGES.DEFAULT]: 'Why Join Our Community'
			},
			SUBSCRIBERS: {
				[LANGUAGES.CHINESE]: '訂閱者',
				[LANGUAGES.DEFAULT]: 'Subscribers'
			},
			SUB_TITLE_1: {
				[LANGUAGES.CHINESE]: '提高廣告商的關注度',
				[LANGUAGES.DEFAULT]: 'Boost Visibility with Advertisers'
			},
			SUB_SLIDE_1: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						吸引廣告商：我們View IQ軟件的使用者是全球最大的廣告商們，他們用此軟件購買Youtube媒體廣告並搜尋創作者，以求達成項目合作。
						<br/>
						獲得資訊：通過使用View IQ軟件，您可以獲知觀眾流量來源以及廣告商們想確保的品牌安全相關數據。
						<br/>
						參與品牌活動：成為認證創作者後，您的頻道會得到我們客戶更多的關注，同時您也會獲得更多的機會被選中參與品牌活動及項目合作
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						ADVERTISERS: Our View IQ software is used by the biggest advertisers in the world to buy YT media and to research creators for project collaborations.
						<br/>
						INSIGHTS: By OAuthing with ViewIQ, you share important audience traffic sources and brand safety data that our Advertisers are looking for.
						<br/>
						BRAND CAMPAIGNS: By becoming verified you increase your channel’s visibility with our clients and chances to be selected for active brand campaigns and project opportunities.
					</Fragment>
				)
			},
			SUB_TITLE_2: {
				[LANGUAGES.CHINESE]: '提高內容質量和觀眾關注度',
				[LANGUAGES.DEFAULT]: 'Improve Content Performance'
			},
			SUB_SLIDE_2: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						視頻：View IQ可以讓您得益於受歡迎視頻和瘋傳的視頻。我們的軟件可以預測並告訴您哪些內容將會成為病毒視頻被瘋傳，以便讓您決定如何部署自己的視頻內容。
						<br/>
						關鍵詞：我們的軟件在關鍵詞搜索方面可提供強大的智能服務，讓您的視頻介紹和標籤用詞更精準，便於登上熱門搜索榜。我們的分析會提供過去30天內受歡迎視頻的具體關鍵詞信息，便於您為自己的視頻選擇最合適的詞彙。
						<br/>
						廣告付費：您可以從頻道、視頻和關鍵詞不同層面了解廣告投放數據，如按每次展示付費（CPM）或按每次播放付費（CPV），同時也可以獲知廣告商們最常投標視頻的關鍵詞。
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						VIDEOS: ViewIQ helps you capitalize on TRENDING and VIRAL videos. Our software identifies content that are about to go viral and deliver you these insights so you’re in the know and help you decide what content to make.
						<br/>
						KEYWORDS: Our software also provides crucial intelligence on a keyword level that will refine your video descriptions and tagging, moving you within top search results. We analytics give you insights into popular videos that are associated with specific keywords within the last 30 days to help you apply the most relevant terms against your content.
						<br/>
						AD SPEND: You will have access to our CPM/CPV data (channel, video, and keyword level), as well as insights on our most bid upon keywords by advertisers.
					</Fragment>
				)
			},
			SUB_TITLE_3: {
				[LANGUAGES.CHINESE]: '競爭分析',
				[LANGUAGES.DEFAULT]: 'Competitive Analysis'
			},
			SUB_SLIDE_3: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						<b>ViewIQ</b>平台通過分析數百萬的Youtube頻道和視頻，為創作者們提供深入的分析數據和洞察信息，來提高競爭力。創作者可以設立與其競爭的頻道清單，便於長期或每天追蹤瞭解這些頻道的受歡迎程度。創作者們也可以根據不同的指標將這些頻道進行對比，指標包括例如30天內訂閱人數增長量、30天內播放量、觀眾態度反饋和關注量等等。
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						<b>ViewIQ</b> platform was built to analyse millions of YouTube channels and videos in order to provide Creators with the competitive edge through deep analysis and insights. Creators can set up lists of competing channels to track their performance over time and on a daily basis. They can compare channels based on various metrics such as 30-day subscriber growth, 30-day views, sentiment and engagement.
					</Fragment>
				)
			}
		},
		ABOUT_US_SLIDE: {
			TITLE: {
				[LANGUAGES.CHINESE]: '關於我們:',
				[LANGUAGES.DEFAULT]: 'ABOUT US'
			},
			SUB_TITLE: {
				[LANGUAGES.CHINESE]: 'CHANNEL FACTORY是為YouTube和社會視頻廣告提供全球性市場分析服務的領先機構。我們進行戰略創新，投入7年以上的時間精力，研製出無可比擬的數據庫和軟件—View IQ，為廣告商和內容創作者在資訊、透明度和軟件使用方面立下了行業準則。',
				[LANGUAGES.DEFAULT]: 'CHANNEL FACTORY Is the leading global marketing analytics solution for YouTube and social video advertising. 7+ years of strategic innovation went into the development of our unparalleled database and software, View IQ. Setting the industry standard for insights, transparency and tools that matter to both advertisers and creators.'
			},
			STAT_TITLE_1: {
				[LANGUAGES.CHINESE]: '廣告展示',
				[LANGUAGES.DEFAULT]: 'AD IMPRESSIONS'
			},
			STAT_VALUE_1: {
				[LANGUAGES.CHINESE]: '超過100億次的',
				[LANGUAGES.DEFAULT]: '10 Billion+'
			},
			STAT_TITLE_2: {
				[LANGUAGES.CHINESE]: '廣告付費',
				[LANGUAGES.DEFAULT]: 'ADS SPENT'
			},
			STAT_VALUE_2: {
				[LANGUAGES.CHINESE]: '超過1億美金的',
				[LANGUAGES.DEFAULT]: '$100 Million+'
			},
			STAT_TITLE_3: {
				[LANGUAGES.CHINESE]: '品牌合作伙伴',
				[LANGUAGES.DEFAULT]: 'BRAND PARTNERS'
			},
			STAT_VALUE_3: {
				[LANGUAGES.CHINESE]: '500位以上的',
				[LANGUAGES.DEFAULT]: '500+'
			}
		},
		BRANDS_SLIDE: {
			TITLE: {
				[LANGUAGES.CHINESE]: <Fragment>認證您的頻道以獲得我們品牌合作伙伴的關注。</Fragment>,
				[LANGUAGES.DEFAULT]: <Fragment>OAUTH YOUR CHANNEL AND GET VISIBILITY WITH <br/>OUR MAJOR BRAND PARTNERS INCLUDING...</Fragment>
			}
		},
		FAQ_SLIDE: {
			TITLE: {
				[LANGUAGES.CHINESE]: '常見問題',
				[LANGUAGES.DEFAULT]: 'READ OUR FAQ'
			},
			FAQ_1_TITLE: {
				[LANGUAGES.CHINESE]: '為什麼我需要在Channel Factory認證？',
				[LANGUAGES.DEFAULT]: 'Why should I become Factory Verified?'
			},
			FAQ_1: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						<div>
							<ol type="1">
								<li className="mb-10">當您在Channel Factory認證後，使用我們平台的世界500強品牌及廣告公司便會看到您的驗證標籤進而了解到您是適合優先合作的創作人。</li>
								<li className="mb-10">卓越的曝光＝更多被廣告商發現和合作的機會</li>
								<li className="mb-10">除了可以獲取一些超讚的工具和功能以幫助您的頻道增長以外，也可以立即了解您頻道的數據分析，而正是這些數據分析使得廣告商決定與哪些創作人合作</li>
							</ol>
						</div>
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						<div>
							<ol type="1">
								<li className="mb-10">When you become Factory Verified, our roster of fortune 500 and agency clients that access our IQ platform, will see your verified badge and know you’re a preferred creator to advertise with.</li>
								<li className="mb-10">Greater visibility = more opportunities to be discovered and chances to work with some amazing advertisers.</li>
								<li className="mb-10">In addition to accessing awesome tools and features that can help you grow your following, you’ll have immediate access to data insights on your channel that matter to advertisers and brands when determining which talent to work with.</li>
							</ol>
						</div>
					</Fragment>
				)
			},
			FAQ_2_TITLE: {
				[LANGUAGES.CHINESE]: '為什麼廣告商會在乎我是否在Channel Factory認證呢？',
				[LANGUAGES.DEFAULT]: 'Why would advertisers care if I was Factory Verified?'
			},
			FAQ_2: {
				[LANGUAGES.CHINESE]: '因為近年YouTube的品牌安全隱患，廣告商現在比以往更在乎他們的廣告在哪些頻道展示以及合作創作人的頻道數據。經我們Channel Factory認證的創作人，他們的影片會經過智能系統逐字的評估和審查，確保影片內容的安全性。所以我們的廣告商在選擇驗證創作人時有更大的信心及知道這些創作人是對品牌安全的。',
				[LANGUAGES.DEFAULT]: 'With recent brand safety issues within YouTube, advertisers now care more than ever how they’re being advertised and who they’re working with. Our Factory Verified creators, have been carefully assessed and vetted so our advertisers can have the confidence and peace of mind when selecting from our verified talent roster, that the creator is brand safe.'
			},
			FAQ_3_TITLE: {
				[LANGUAGES.CHINESE]: '我如何能成為Channel Factory認證的創作人呢？',
				[LANGUAGES.DEFAULT]: 'How do I become Factory Verified?'
			},
			FAQ_3: {
				[LANGUAGES.CHINESE]: '很簡單！您只要填寫我們的申請表格，您就會收到一份由我們24小時在線的專業創作人團隊發出的確認信，確認您是否有資格認證。如果乎合資格的話，郵件裡還會有一條連接可以讓您在我們的IQ平台上進行驗證。',
				[LANGUAGES.DEFAULT]: 'It’s easy! Once you’ve filled out our application form, you will receive a confirmation e-mail from our dedicated influencer team within 24/48 hours letting you know if you’re eligible to be Factory Verified. If you are, the e-mail will also contain a link allowing you to authenticate your account with our platform, IQ.'
			},
			FAQ_4_TITLE: {
				[LANGUAGES.CHINESE]: '為什麼我一定要用自己的社交賬號認證呢？',
				[LANGUAGES.DEFAULT]: 'Why do I have to authenticate using my social media accounts?'
			},
			FAQ_4: {
				[LANGUAGES.CHINESE]: '通過您自己的社交賬號認證，可以讓我們了解到您是這個賬號的擁有者，同時可以開始分析您個人的IQ簡介。不用擔心，我們絕對不會以您的名義評論，轉發，發佈任何內容，我們也不會儲存您的賬號密碼。',
				[LANGUAGES.DEFAULT]: <Fragment>Authenticating with your social account lets us know that you’re the owner of the accounts and enables the analytics to populate in your personal IQ profile. <strong>Don’t worry</strong> – we’ll never comment, like, or post on your behalf, and we don’t store your password.</Fragment>
			},
			FAQ_5_TITLE: {
				[LANGUAGES.CHINESE]: '為什麼您們要詢問獲取我的頻道的管理權呢？',
				[LANGUAGES.DEFAULT]: 'Why are you asking me to allow Management Access to my channel?'
			},
			FAQ_5: {
				[LANGUAGES.CHINESE]: '這令我們可以將您的YouTube視頻內容轉譯成文字（音頻到文字的翻譯），進而分析您的內容是否品牌安全以及您經常發佈內容的類型。我們絕對不會行使您頻道的任何“管理權力”。',
				[LANGUAGES.DEFAULT]: 'This allows us to pull the transcripts (from audio to text translations) from your YouTube videos to analyse how safe and what kind of content you regularly post. We will absolutely NOT exercise any of the ‘management permission’ features within your channel.'
			},
			FAQ_6_TITLE: {
				[LANGUAGES.CHINESE]: '您如何絕對我是否乎合資格呢？',
				[LANGUAGES.DEFAULT]: 'How do you determine if I’m eligible?'
			},
			FAQ_6: {
				[LANGUAGES.CHINESE]: '我們的評估中涉及多重因素，舉例來說有內容質量，影片及觀眾的情緒，及創作人與觀眾的互動等等。',
				[LANGUAGES.DEFAULT]: 'Multiple factors go into our evaluation including content quality, sentiment, engagement, just to name a few…'
			},
			FAQ_7_TITLE: {
				[LANGUAGES.CHINESE]: '在我授權給IQ之後會發生什麼？',
				[LANGUAGES.DEFAULT]: 'What happens after I authenticate my account with IQ?'
			},
			FAQ_7: {
				[LANGUAGES.CHINESE]: '我們會立即開始查核您的頻道數據，5天內您就會收到一封郵件告知您已經成為Channel Factory的認證創作人，就是這麼簡單~',
				[LANGUAGES.DEFAULT]: 'We will immediately begin reviewing your channel data, and at the end of 5 days you will receive an email from us notifying you if you’ve been Factory Verified. It’s that simple!'
			},
			FAQ_8_TITLE: {
				[LANGUAGES.CHINESE]: '您們將如何處理我的社交數據？',
				[LANGUAGES.DEFAULT]: 'What are you doing with my social data?'
			},
			FAQ_8: {
				[LANGUAGES.CHINESE]: '非常重要，您要知道您的頻道數據不會分享給其他創作人，只有我們內部團隊在審查您的驗證過程以及經篩選的主要品牌及廣告公司在進行調查以及廣告購買活動或計劃的時候才能獲得您的社交數據。',
				[LANGUAGES.DEFAULT]: <Fragment>It’s <strong>VERY</strong> important for you to know that data from your channel will NOT be shared with other creators and will only be available to our internal team reviewing your verification process, as well as select agencies and brands that have buying power and who access our platform for research and campaign planning.</Fragment>
			},
			FAQ_9_TITLE: {
				[LANGUAGES.CHINESE]: '廣告公司或品牌如何與我合作？',
				[LANGUAGES.DEFAULT]: 'How do Advertisers or Brands work with me?'
			},
			FAQ_9: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						IQ為我們的客戶和創作人提供全面的廣告服務。例如根據IQ為您分析YouTube頻道的簡介，廣告公司和品牌會更容易了解您的頻道並將您加入到他們的廣告營銷計劃中。<br/>
						在其他案例中，我們的創作人團隊會代表客戶聯絡您們，根據客戶計劃的內容創作方面，和您們進行細節協商及確認。
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: 'IQ serves as a beginning to end advertising solution for our clients and influencer team. So, for example- based on your YouTube channel profile within IQ, agencies or brands can easily assess your channel and incorporate you for their advertising campaigns (custom projects or creative targeting). In some cases, representatives from our influencer team will serve as the client’s proxy by reaching out to you, handling negotiations (project terms), and payment.'
			},
			FAQ_10_TITLE: {
				[LANGUAGES.CHINESE]: '成為Channel Factory認證創作人，我會獲得報酬嗎？',
				[LANGUAGES.DEFAULT]: 'Will I be paid for becoming Factory Verified?'
			},
			FAQ_10: {
				[LANGUAGES.CHINESE]: '隨著您成為Channel Factory的認證創作人，您會以我們優選創作人的身份獲得更多客戶的曝光和關注度，增加被客戶發現並被選取合作的機會。越多的機會帶來越多的收入。',
				[LANGUAGES.DEFAULT]: 'By becoming Factory Verified, you become more visible as a preferred creator to our clients. Which increases your chances of being discovered for an advertising need or project. Earning you the opportunity to increase your income. Please keep in mind compensation amounts vary by campaign and project.'
			},
			FAQ_11_TITLE: {
				[LANGUAGES.CHINESE]: '您們是誰？',
				[LANGUAGES.DEFAULT]: 'Who are you guys?'
			},
			FAQ_11: {
				[LANGUAGES.CHINESE]: <Fragment>點擊我們的<a href="https://www.instagram.com/channelfactory/" target="_blank">Instagram <i className="fa fa-instagram"/></a>，了解更多關於我們的團隊。</Fragment>,
				[LANGUAGES.DEFAULT]: <Fragment>Check out our <a href="https://www.instagram.com/channelfactory/" target="_blank">Instagram <i className="fa fa-instagram"/></a> to meet our team!</Fragment>
			},
			FAQ_12_TITLE: {
				[LANGUAGES.CHINESE]: '更多的問題？',
				[LANGUAGES.DEFAULT]: 'More Questions?'
			},
			FAQ_12: {
				[LANGUAGES.CHINESE]: <Fragment>請將您的問題發送到<a href="mailto:creators@channelfactory.com">creators@channelfactory.com</a></Fragment>,
				[LANGUAGES.DEFAULT]: <Fragment>Please email <a href="mailto:creators@channelfactory.com">creators@channelfactory.com</a> with any questions <i className="fa fa-smile-o"/></Fragment>
			}
		},
		FOOTER: {
			OFFICES_TITLE: {
				[LANGUAGES.CHINESE]: '我們的地址',
				[LANGUAGES.DEFAULT]: 'Our Offices'
			},
			OFFICES: {
				[LANGUAGES.CHINESE]: (
					<Fragment>
						比華利山，加利福尼亞洲，美國（總部）<br/>
						舊金山，美國<br/>
						芝加哥，美國<br/>
						紐約，美國<br/>
						卡爾可夫，烏克蘭<br/>
						北京，中國<br/>
					</Fragment>
				),
				[LANGUAGES.DEFAULT]: (
					<Fragment>
						Beverly Hills, CA, US (Headquarters)<br/>
						San Francisco, US<br/>
						Chicago, US<br/>
						New York, US<br/>
						Kharkiv, Ukraine<br/>
						Beijing, China<br/>
					</Fragment>
				)
			},
			PHONE: {
				[LANGUAGES.CHINESE]: '電話',
				[LANGUAGES.DEFAULT]: 'Phone'
			},
			FAX: {
				[LANGUAGES.CHINESE]: '傳真',
				[LANGUAGES.DEFAULT]: 'Fax'
			},
			COPYRIGHT: {
				[LANGUAGES.CHINESE]: <Fragment>2010-{new Date().getFullYear()} 版權所有. Channel Factory LLC</Fragment>,
				[LANGUAGES.DEFAULT]: <Fragment>© 2010-{new Date().getFullYear()} All Rights Reserved. Channel Factory LLC</Fragment>
			},
			DATA_COMPLIANCE: {
				[LANGUAGES.CHINESE]: '数据合规性',
				[LANGUAGES.DEFAULT]: 'Data compliance'
			},
			PP: {
				[LANGUAGES.CHINESE]: '隐私政策',
				[LANGUAGES.DEFAULT]: 'Privacy Policy'
			},
			GDPR: {
				[LANGUAGES.CHINESE]: '歐盟一般資料保護規範',
				[LANGUAGES.DEFAULT]: 'Statement of GDPR Compliance'
			}
		}
	},
	REGISTRATION_PAGE: {
		TITLE: {
			[LANGUAGES.CHINESE]: '註冊',
			[LANGUAGES.DEFAULT]: 'Registration'
		},
		FIRST_NAME: {
			[LANGUAGES.CHINESE]: '名字（必填）',
			[LANGUAGES.DEFAULT]: 'First Name (required)'
		},
		LAST_NAME: {
			[LANGUAGES.CHINESE]: '姓氏（必填）',
			[LANGUAGES.DEFAULT]: 'Last Name (required)'
		},
		EMAIL: {
			[LANGUAGES.CHINESE]: '電子郵件（必填）',
			[LANGUAGES.DEFAULT]: 'Email (required)'
		},
		COMPANY: {
			[LANGUAGES.CHINESE]: '公司（必填）',
			[LANGUAGES.DEFAULT]: 'Company (required)'
		},
		PHONE_NUMBER: {
			[LANGUAGES.CHINESE]: '電話號碼（必填）',
			[LANGUAGES.DEFAULT]: 'Phone Number (required)'
		},
		PASSWORD: {
			[LANGUAGES.CHINESE]: '密碼（必填）',
			[LANGUAGES.DEFAULT]: 'Password (required)'
		},
		CONFIRM_PASSWORD: {
			[LANGUAGES.CHINESE]: '確認密碼（必填）',
			[LANGUAGES.DEFAULT]: 'Confirm Password (required)'
		},
		AD_SPEND: {
			[LANGUAGES.CHINESE]: '年度广告支出（必填）',
			[LANGUAGES.DEFAULT]: 'Annual Ad Spend (required)'
		},
		USER_TYPE: {
			[LANGUAGES.CHINESE]: '用户类型（必填）',
			[LANGUAGES.DEFAULT]: 'Type of user (required)'
		},
		AGENCY_USER_TYPE: {
			[LANGUAGES.CHINESE]: '机构',
			[LANGUAGES.DEFAULT]: 'Agency'
		},
		BRAND_USER_TYPE: {
			[LANGUAGES.CHINESE]: '牌',
			[LANGUAGES.DEFAULT]: 'Brand'
		},
		SUBSCRIBE: {
			[LANGUAGES.CHINESE]: '我想收到Channel Factory的电子邮件更新和见解',
			[LANGUAGES.DEFAULT]: 'I want to receive email updates and insights from Channel Factory'
		},
		TERMS_ACCEPT_TITLE: {
			[LANGUAGES.CHINESE]: '我讀過了',
			[LANGUAGES.DEFAULT]: 'I have read the'
		},
		TERMS_OF_SERVICE: {
			[LANGUAGES.CHINESE]: '服務條款,',
			[LANGUAGES.DEFAULT]: 'Terms of Service,'
		},
		PRIVACY_POLICY: {
			[LANGUAGES.CHINESE]: '隱私政策',
			[LANGUAGES.DEFAULT]: 'Privacy Policy,'
		},
		TERMS_ACCEPT_AND: {
			[LANGUAGES.CHINESE]: '和',
			[LANGUAGES.DEFAULT]: 'and'
		},
		GDPR_COMPLIANCE: {
			[LANGUAGES.CHINESE]: '通用数据保护法规（GDPR）声明',
			[LANGUAGES.DEFAULT]: 'statement of GDPR compliance.'
		},
		REGISTER_BUTTON: {
			[LANGUAGES.CHINESE]: '寄存器',
			[LANGUAGES.DEFAULT]: 'REGISTER'
		},
		HAVE_ACCOUNT: {
			[LANGUAGES.CHINESE]: '已經有一個帳戶？',
			[LANGUAGES.DEFAULT]: 'Already have an account?'
		},
		AUTHORIZE_GOOGLE: {
			[LANGUAGES.CHINESE]: '與Google授權',
			[LANGUAGES.DEFAULT]: 'Authorize with Google'
		},
		EMPTY_SELECTION: {
			[LANGUAGES.CHINESE]: '请选择',
			[LANGUAGES.DEFAULT]: 'Please select'
		}
	},
	LOGIN_PAGE: {
		EMAIL: {
			[LANGUAGES.CHINESE]: '電子郵件',
			[LANGUAGES.DEFAULT]: 'Email'
		},
		PASSWORD: {
			[LANGUAGES.CHINESE]: '密碼',
			[LANGUAGES.DEFAULT]: 'Password'
		},
		LOGIN: {
			[LANGUAGES.CHINESE]: '登錄',
			[LANGUAGES.DEFAULT]: 'Login'
		},
		LOGIN_WITH_GOOGLE: {
			[LANGUAGES.CHINESE]: '使用GOOGLE登錄',
			[LANGUAGES.DEFAULT]: 'Login with google'
		},
		CREATE_ACCOUNT: {
			[LANGUAGES.CHINESE]: '創建一個新賬戶',
			[LANGUAGES.DEFAULT]: 'Create a new account'
		},
		FORGOT_PASSWORD: {
			[LANGUAGES.CHINESE]: '忘記密碼了嗎？',
			[LANGUAGES.DEFAULT]: 'Forgot your password?'
		}
	},
	RESET_PASSWORD: {
		ENTER_EMAIL: {
			[LANGUAGES.CHINESE]: '在下面輸入您的電子郵件地址，我們會讓您回到正軌。',
			[LANGUAGES.DEFAULT]: 'Enter your email address below and we\'ll get you back on track.'
		},
		PROVIDE_VALID_EMAIL: {
			[LANGUAGES.CHINESE]: '請提供有效的電郵',
			[LANGUAGES.DEFAULT]: 'Please provide valid email'
		},
		ERROR_WHILE_RESET: {
			[LANGUAGES.CHINESE]: '重置密碼時出錯',
			[LANGUAGES.DEFAULT]: 'Error while resetting password'
		},
		EMAIL_NOT_FOUND: {
			[LANGUAGES.CHINESE]: '未找到此電子郵件。',
			[LANGUAGES.DEFAULT]: 'This email was not found.'
		},
		RESET_LINK_SENT: {
			[LANGUAGES.CHINESE]: '重置密碼鏈接已發送到您的電子郵件。',
			[LANGUAGES.DEFAULT]: 'A reset password link has been sent to your email.'
		},
		RESET_BUTTON: {
			[LANGUAGES.CHINESE]: '重設密碼',
			[LANGUAGES.DEFAULT]: 'Reset password'
		},
		OK_BUTTON: {
			[LANGUAGES.CHINESE]: '好',
			[LANGUAGES.DEFAULT]: 'Ok'
		}
	}
};

function browserLanguage() {
	let result = LANGUAGES.DEFAULT;
	_.each(LANGUAGE_INFO, (info, key) => {
		if(_.includes(info.codes, _.toLower(navigator.language))) {
			result = key;
		}
	});
	return result;
}

export function currentLanguage() {
	return localStorage.getItem('language') || browserLanguage();
}

export function setCurrentLanguage(language) {
	localStorage.setItem('language', language);
}

function localized(message) {
	return message[currentLanguage()] || '';
}

export default localized;
